module.exports = __webpack_public_path__ + "img/contact-drip.31841633.png";